import { render, staticRenderFns } from "./form.vue?vue&type=template&id=0a52bb5e&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=0a52bb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52bb5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a52bb5e')) {
      api.createRecord('0a52bb5e', component.options)
    } else {
      api.reload('0a52bb5e', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=0a52bb5e&scoped=true&", function () {
      api.rerender('0a52bb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/stockout/apply/form.vue"
export default component.exports